import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../../utils/index.js";
import { A } from "../../A/index.js";
import { Button } from "../../Button/index.js";
import { PromoCode } from "../../PromoCode/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { deriveChildEmphasis } from "../Module.types.js";
const ModuleAction_ModuleAction = /*#__PURE__*/ forwardRef(function({ primaryAction, secondaryAction, promoCode, children, ...sectionProps }, ref) {
    const buttonEmphasis = deriveChildEmphasis(sectionProps.emphasis);
    const renderAction = (config, defaultType)=>{
        const { as, ...rest } = config;
        if ('a' === as) return /*#__PURE__*/ jsx(A, {
            ...rest,
            type: rest.type ?? defaultType,
            emphasis: buttonEmphasis
        });
        return /*#__PURE__*/ jsx(Button, {
            ...rest,
            type: rest.type ?? defaultType,
            emphasis: buttonEmphasis
        });
    };
    const defaultContent = /*#__PURE__*/ jsxs("div", {
        className: "-mt-2 flex w-full flex-col flex-wrap gap-3 @2xl:-mt-4 @2xl:w-auto @2xl:flex-row",
        children: [
            secondaryAction && renderAction(secondaryAction, 'secondary'),
            primaryAction && renderAction(primaryAction, 'primary'),
            promoCode && /*#__PURE__*/ jsx(PromoCode, {
                ...promoCode,
                emphasis: buttonEmphasis
            })
        ]
    });
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        innerSlotClassName: cn('withImage' === sectionProps.display && '@2xl:items-center', sectionProps.innerSlotClassName),
        contentSlotClassName: cn('simpleSplit' === sectionProps.display && '@2xl:items-center', sectionProps.contentSlotClassName),
        children: children ?? defaultContent
    });
});
export { ModuleAction_ModuleAction as ModuleAction };
